/*
  LITIO 13-10 — punto 9: confronto fra prodotti, senza app.
  I dati tecnici arrivano gia' scritti nella pagina dalla scheda prodotto
  (snippet litio-confronto.liquid). Qui si tiene la scelta nella sessione,
  si disegna la barretta in fondo e la tabella del confronto.
*/
(function () {
  'use strict';

  var CHIAVE = 'litio-confronto';
  var MAX = 4;

  function leggi() {
    try {
      var g = sessionStorage.getItem(CHIAVE);
      return g ? JSON.parse(g) : [];
    } catch (e) {
      return [];
    }
  }

  function salva(lista) {
    try {
      sessionStorage.setItem(CHIAVE, JSON.stringify(lista));
    } catch (e) { /* in incognito puo' non andare: pazienza, resta in pagina */ }
  }

  var scelti = leggi();

  function parole() {
    var lg = (document.documentElement.lang || 'it').slice(0, 2).toLowerCase();
    var v = {
      it: { conf: 'Confronta', vuota: 'Scegli almeno due prodotti', pulisci: 'Svuota',
            titolo: 'Confronto', chiudi: 'Chiudi', vedi: 'Vedi la scheda',
            max: 'Puoi confrontare al massimo 4 prodotti', car: 'Caratteristica' },
      en: { conf: 'Compare', vuota: 'Pick at least two products', pulisci: 'Clear',
            titolo: 'Comparison', chiudi: 'Close', vedi: 'View product',
            max: 'You can compare up to 4 products', car: 'Specification' },
      de: { conf: 'Vergleichen', vuota: 'Mindestens zwei Produkte wählen', pulisci: 'Leeren',
            titolo: 'Vergleich', chiudi: 'Schließen', vedi: 'Zum Produkt',
            max: 'Es lassen sich höchstens 4 Produkte vergleichen', car: 'Merkmal' },
      fr: { conf: 'Comparer', vuota: 'Choisissez au moins deux produits', pulisci: 'Vider',
            titolo: 'Comparatif', chiudi: 'Fermer', vedi: 'Voir le produit',
            car: 'Caractéristique', max: 'Vous pouvez comparer 4 produits au maximum' }
    };
    return v[lg] || v.en;
  }

  var P = parole();

  function barra() {
    var b = document.getElementById('litio-confronto-barra');
    if (!b) {
      b = document.createElement('div');
      b.id = 'litio-confronto-barra';
      b.className = 'litio-confronto-barra';
      b.setAttribute('role', 'region');
      document.body.appendChild(b);
    }
    if (scelti.length === 0) {
      b.classList.remove('aperta');
      b.innerHTML = '';
      return;
    }
    var html = '<div class="litio-confronto-barra__dentro">';
    html += '<div class="litio-confronto-barra__pezzi">';
    scelti.forEach(function (x) {
      html += '<span class="litio-confronto-pezzo">' +
        (x.img ? '<img src="' + x.img + '" alt="" loading="lazy" width="36" height="36">' : '') +
        '<span>' + testoSicuro(x.t) + '</span>' +
        '<button type="button" class="litio-confronto-togli" data-h="' + testoSicuro(x.h) +
        '" aria-label="' + P.chiudi + '">&times;</button></span>';
    });
    html += '</div><div class="litio-confronto-barra__bottoni">' +
      '<button type="button" class="litio-confronto-svuota">' + P.pulisci + '</button>' +
      '<button type="button" class="litio-confronto-apri button button--primary"' +
      (scelti.length < 2 ? ' disabled title="' + P.vuota + '"' : '') + '>' +
      P.conf + ' (' + scelti.length + ')</button></div></div>';
    b.innerHTML = html;
    b.classList.add('aperta');
  }

  function testoSicuro(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function segnaCaselle() {
    var presi = {};
    scelti.forEach(function (x) { presi[x.h] = true; });
    document.querySelectorAll('.litio-confronto-casella').forEach(function (c) {
      c.checked = !!presi[c.value];
    });
  }

  function aggiungi(casella) {
    if (scelti.length >= MAX) {
      casella.checked = false;
      alert(P.max);
      return;
    }
    var dati;
    try {
      dati = JSON.parse(casella.getAttribute('data-confronto'));
    } catch (e) {
      return;
    }
    if (!scelti.some(function (x) { return x.h === dati.h; })) {
      scelti.push(dati);
      salva(scelti);
    }
    barra();
  }

  function togli(handle) {
    scelti = scelti.filter(function (x) { return x.h !== handle; });
    salva(scelti);
    barra();
    segnaCaselle();
  }

  function tabella() {
    var chiavi = [];
    scelti.forEach(function (x) {
      (x.r || []).forEach(function (r) {
        if (chiavi.indexOf(r.k) === -1) chiavi.push(r.k);
      });
    });
    var html = '<table class="litio-confronto-tabella"><thead><tr><th scope="col">' + P.car + '</th>';
    scelti.forEach(function (x) {
      html += '<th scope="col">' + (x.img ? '<img src="' + x.img + '" alt="" width="70" height="70">' : '') +
        '<a href="' + testoSicuro(x.u) + '">' + testoSicuro(x.t) + '</a>' +
        '<span class="litio-confronto-prezzo">' + testoSicuro(x.p) + '</span></th>';
    });
    html += '</tr></thead><tbody>';
    chiavi.forEach(function (k) {
      var valori = scelti.map(function (x) {
        var t = (x.r || []).filter(function (r) { return r.k === k; })[0];
        return t ? t.v : '';
      });
      var diversi = valori.some(function (v) { return v !== valori[0]; });
      html += '<tr' + (diversi ? ' class="litio-confronto-diverso"' : '') +
        '><th scope="row">' + testoSicuro(k) + '</th>';
      valori.forEach(function (v) {
        html += '<td>' + (v ? testoSicuro(v) : '<span aria-hidden="true">—</span>') + '</td>';
      });
      html += '</tr>';
    });
    html += '</tbody></table>';
    return html;
  }

  function apri() {
    if (scelti.length < 2) return;
    var f = document.getElementById('litio-confronto-finestra');
    if (!f) {
      f = document.createElement('div');
      f.id = 'litio-confronto-finestra';
      f.className = 'litio-confronto-finestra';
      document.body.appendChild(f);
    }
    f.innerHTML = '<div class="litio-confronto-finestra__dentro" role="dialog" aria-modal="true" aria-label="' +
      P.titolo + '"><div class="litio-confronto-finestra__testa"><h2>' + P.titolo + '</h2>' +
      '<button type="button" class="litio-confronto-chiudi" aria-label="' + P.chiudi + '">&times;</button></div>' +
      '<div class="litio-confronto-finestra__corpo">' + tabella() + '</div></div>';
    f.classList.add('aperta');
    document.documentElement.classList.add('litio-confronto-aperto');
    var c = f.querySelector('.litio-confronto-chiudi');
    if (c) c.focus();
  }

  function chiudi() {
    var f = document.getElementById('litio-confronto-finestra');
    if (f) f.classList.remove('aperta');
    document.documentElement.classList.remove('litio-confronto-aperto');
  }

  document.addEventListener('change', function (e) {
    var c = e.target.closest && e.target.closest('.litio-confronto-casella');
    if (!c) return;
    if (c.checked) aggiungi(c); else togli(c.value);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.litio-confronto-togli')) {
      togli(e.target.closest('.litio-confronto-togli').getAttribute('data-h'));
    } else if (e.target.closest('.litio-confronto-svuota')) {
      scelti = []; salva(scelti); barra(); segnaCaselle();
    } else if (e.target.closest('.litio-confronto-apri')) {
      apri();
    } else if (e.target.closest('.litio-confronto-chiudi')) {
      chiudi();
    } else if (e.target.id === 'litio-confronto-finestra') {
      chiudi();
    }
  });

  document.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') chiudi();
  });

  function avvia() {
    barra();
    segnaCaselle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
  // dopo un filtro la griglia viene riscritta: rimetto i segni di spunta
  new MutationObserver(function () { segnaCaselle(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
